export default __webpack_public_path__ + "static/xtapa-1b1d9c0abc13f15cc59367135f8d3d9a.jpg";